import { BabylonjsModule } from '@modules/babylonjs/src/BabylonjsModule';
import { Layers } from '@modules/core';
import { useZed } from '@modules/core/src/react/useZed';
import { StandardModule } from '@modules/standard/src/StandardModule';
import zams from '@zams/logger/zed';
import { useEffect, useState } from 'react';

import { useScreen } from '@modules/tourdanji/src/react/hooks/useScreen';

import { getTourDanjiZamsParams, TourDanjiModule } from '../TourDanjiModule';

import { GUIDE_3D_TOUR_LINES, GUIDE_3D_TOUR_TITLE, GuideSection } from './GuideContents';
import { InfoTooltip } from './InfoTooltip';
import styles from './styles/DanjiInfoIcon.module.css';

export const DanjiInfoIcon = () => {
  const screenInfo = useScreen();
  const zed = useZed<[BabylonjsModule, StandardModule, TourDanjiModule]>();
  const [isInteriorActive, setIsInteriorActive] = useState(false);

  useEffect(() => {
    if (!zed) return;
    const observer = zed.api.observer.onUnitViewStateChanged.add(({ isEntering }) => {
      setIsInteriorActive(isEntering);
    });
    return () => {
      observer.remove();
    };
  }, [zed]);

  if (screenInfo.isInComponent || isInteriorActive) {
    return null;
  }

  const containerClass = screenInfo.isDesktop ? styles.containerDesktop : styles.container;

  return (
    <div className={containerClass} style={{ zIndex: Layers.UI_CONTENTS + 1 }}>
      <InfoTooltip
        ariaLabel="3D단지투어 안내"
        iconSize={24}
        anchor="icon"
        onToggle={(open) => {
          zams
            .z157({
              ...getTourDanjiZamsParams(),
              status: open ? '1' : '0',
            })
            .send();
        }}>
        <GuideSection title={GUIDE_3D_TOUR_TITLE} lines={GUIDE_3D_TOUR_LINES} />
      </InfoTooltip>
    </div>
  );
};
